var user = localStorage.getItem('userInfo');
if (user) {


    var userInfo = JSON.parse(user);

    var m2 = [
        {
            "type": 'header',
            "href": '#',
            "icon": '',
            "entity": '',
            "label": 'Pagine'
        },
        {
            "type": 'item',
            "href": '/',
            "icon": 'home',
            "entity": '',
            "label": 'Dashboard'
        },
        {
            "type": 'item',
            "href": '/page/Calendar',
            "icon": 'calendar-days',
            "entity": '',
            "label": 'Calendario'
        },
        {
            "type": 'item',
            "href": '/entity/event',
            "icon": 'calendar',
            "entity": 'event',
            "label": 'Eventi'
        },
        {
            "type": 'item',
            "href": '/entity/publication',
            "icon": 'book',
            "entity": 'publication',
            "label": 'Pubblicazioni'
        },
        {
            "type": 'item',
            "href": '/entity/association',
            "icon": 'globe',
            "entity": 'association',
            "label": 'Associazioni'
        },
        {
            "type": 'item',
            "href": '/entity/certificate_template',
            "icon": 'file',
            "entity": 'certificate_template',
            "label": 'Template certificati'
        },
        {
            "type": 'item',
            "href": '/entity/gyv_episode_user',
            "icon": 'clock',
            "entity": 'gyv_episode_user',
            "label": 'Minutaggi'
        },
        {
            "type": 'header',
            "label": 'Corsi'
        },
        {
            "type": 'item',
            "href": '/entity/category',
            "icon": 'tag',
            "entity": 'category',
            "label": 'Categorie'
        },
        /*     {
                "type": 'item',
                "href": '/entity/path',
                "icon": 'folder',
                "entity": 'path',
                "label": 'Percorsi'
            }, */
        {
            "type": 'item',
            "href": '/entity/course',
            "icon": 'graduation-cap',
            "entity": 'course',
            "label": 'Corsi'
        },
        {
            "type": 'header',
            "href": '#',
            "icon": '',
            "entity": '',
            "label": 'Utente'
        },
        {
            "type": 'item',
            "href": '/settings',
            "icon": 'user-gear',
            "entity": '',
            "label": 'Profilo'
        },
        {
            "type": 'folder',
            "href": '#',
            "icon": 'cogs',
            "entity": '',
            "label": 'Impostazioni',
            "items": [
                {
                    "type": 'item',
                    "href": '/entity/user',
                    "entity": 'user',
                    "label": 'Utenti'
                },
                {
                    "type": 'item',
                    "href": '/entity/role',
                    "entity": 'role',
                    "label": 'Ruoli'
                },
                {
                    "type": 'item',
                    "href": '/entity/user_group',
                    "entity": 'user_group',
                    "label": 'Gruppi'
                },
                {
                    "type": 'item',
                    "href": '/entity/user_entity_saved_filters',
                    "entity": 'user_entity_saved_filters',
                    "label": 'Filtri salvati'
                },
                {
                    "type": 'item',
                    "href": '/entity/user_entity_preferences',
                    "entity": 'user_entity_preferences',
                    "label": 'Preferenze entità'
                },
            ]
        },
        {
            "type": 'item',
            "href": '/logout',
            "icon": 'arrow-right-from-bracket',
            "entity": '',
            "label": 'Logout'
        }
    ]


    if (userInfo.level === 2) {
        m2 = m2 = [
            {
                "type": 'header',
                "href": '#',
                "icon": '',
                "entity": '',
                "label": 'Pagine'
            },
            {
                "type": 'item',
                "href": '/',
                "icon": 'home',
                "entity": '',
                "label": 'Dashboard'
            },
            {
                "type": 'item',
                "href": '/page/Calendar',
                "icon": 'calendar-days',
                "entity": '',
                "label": 'Calendario'
            },
            {
                "type": 'item',
                "href": '/entity/event',
                "icon": 'calendar',
                "entity": 'event',
                "label": 'Eventi'
            },
            {
                "type": 'header',
                "label": 'Corsi'
            },
            {
                "type": 'item',
                "href": '/entity/category',
                "icon": 'tag',
                "entity": 'category',
                "label": 'Categorie'
            },
            {
                "type": 'item',
                "href": '/entity/course',
                "icon": 'graduation-cap',
                "entity": 'course',
                "label": 'Corsi'
            },
            {
                "type": 'header',
                "href": '#',
                "icon": '',
                "entity": '',
                "label": 'Utente'
            },
            {
                "type": 'item',
                "href": '/settings',
                "icon": 'user-gear',
                "entity": '',
                "label": 'Profilo'
            },
            {
                "type": 'folder',
                "href": '#',
                "icon": 'cogs',
                "entity": '',
                "label": 'Impostazioni',
                "items": [
                    {
                        "type": 'item',
                        "href": '/entity/user_entity_saved_filters',
                        "entity": 'user_entity_saved_filters',
                        "label": 'Filtri salvati'
                    },
                    {
                        "type": 'item',
                        "href": '/entity/user_entity_preferences',
                        "entity": 'user_entity_preferences',
                        "label": 'Preferenze entità'
                    },
                ]
            },
            {
                "type": 'item',
                "href": '/logout',
                "icon": 'arrow-right-from-bracket',
                "entity": '',
                "label": 'Logout'
            }
        ]
    }

    if (userInfo.level === 1) {

        m2 = [
            {
                "type": 'header',
                "href": '#',
                "icon": '',
                "entity": '',
                "label": 'Pagine'
            },
            {
                "type": 'item',
                "href": '/',
                "icon": 'home',
                "entity": '',
                "label": 'Dashboard'
            },
            {
                "type": 'header',
                "href": '#',
                "icon": '',
                "entity": '',
                "label": 'Utente'
            },
            {
                "type": 'item',
                "href": '/settings',
                "icon": 'user-gear',
                "entity": '',
                "label": 'Profilo'
            },
            {
                "type": 'folder',
                "href": '#',
                "icon": 'cogs',
                "entity": '',
                "label": 'Impostazioni',
                "items": [
                    {
                        "type": 'item',
                        "href": '/entity/user',
                        "entity": 'user',
                        "label": 'Utenti'
                    },
                    {
                        "type": 'item',
                        "href": '/entity/user_group',
                        "entity": 'user_group',
                        "label": 'Gruppi'
                    },
                    {
                        "type": 'item',
                        "href": '/entity/user_entity_saved_filters',
                        "entity": 'user_entity_saved_filters',
                        "label": 'Filtri salvati'
                    },
                    {
                        "type": 'item',
                        "href": '/entity/user_entity_preferences',
                        "entity": 'user_entity_preferences',
                        "label": 'Preferenze entità'
                    },
                ]
            },
            {
                "type": 'item',
                "href": '/logout',
                "icon": 'arrow-right-from-bracket',
                "entity": '',
                "label": 'Logout'
            }
        ]

    }
}
export const menu = m2;